import React from 'react';
import {Helmet} from 'react-helmet';
import {buildCanonicalUrl} from '../../seo/canonical';

export default function CanonicalMeta({pathname, search}) {
    const canonical = buildCanonicalUrl(pathname, search);
    if (!canonical) return null;

    return (
        <Helmet>
            <link rel="canonical" href={canonical}/>
            <meta property="og:url" content={canonical}/>
            <meta name="twitter:url" content={canonical}/>
        </Helmet>
    );
}
